/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * <p>Holds allowed filters for searching reports<\/p>
 **/
export var SearchCriteriaField;
(function (SearchCriteriaField) {
    SearchCriteriaField["SERVICE_PROVIDER_ID"] = "SERVICE_PROVIDER_ID";
    SearchCriteriaField["TERM"] = "TERM";
    SearchCriteriaField["REPORT_TYPE"] = "REPORT_TYPE";
    SearchCriteriaField["REPORT_STATUS"] = "REPORT_STATUS";
    SearchCriteriaField["REPORT_PARENT_PATH"] = "REPORT_PARENT_PATH";
    SearchCriteriaField["CREATED_BY"] = "CREATED_BY";
    SearchCriteriaField["QUERY_ID"] = "QUERY_ID";
})(SearchCriteriaField || (SearchCriteriaField = {}));
